export const allowedZipcodes = {
  nl: [
    "4301",
    "4302",
    "4303",
    "4304",
    "4305",
    "4306",
    "4307",
    "4308",
    "4309",
    "4310",
    "4311",
    "4312",
    "4313",
    "4314",
    "4315",
    "4316",
    "4317",
    "4318",
    "4319",
    "4320",
    "4321",
    "4322",
    "4323",
    "4324",
    "4325",
    "4326",
    "4327",
    "4328",
    "4329",
    "4330",
    "4331",
    "4332",
    "4333",
    "4334",
    "4335",
    "4336",
    "4337",
    "4338",
    "4339",
    "4340",
    "4341",
    "4342",
    "4343",
    "4344",
    "4345",
    "4346",
    "4347",
    "4348",
    "4349",
    "4350",
    "4351",
    "4352",
    "4353",
    "4354",
    "4355",
    "4356",
    "4357",
    "4358",
    "4359",
    "4360",
    "4361",
    "4362",
    "4363",
    "4364",
    "4365",
    "4366",
    "4367",
    "4368",
    "4369",
    "4370",
    "4371",
    "4372",
    "4373",
    "4374",
    "4375",
    "4376",
    "4377",
    "4378",
    "4379",
    "4380",
    "4381",
    "4382",
    "4383",
    "4384",
    "4385",
    "4386",
    "4387",
    "4388",
    "4389",
    "4390",
    "4391",
    "4392",
    "4393",
    "4394",
    "4395",
    "4396",
    "4397",
    "4398",
    "4399",
    "4400",
    "4401",
    "4402",
    "4403",
    "4404",
    "4405",
    "4406",
    "4407",
    "4408",
    "4409",
    "4410",
    "4411",
    "4412",
    "4413",
    "4414",
    "4415",
    "4416",
    "4417",
    "4418",
    "4419",
    "4420",
    "4421",
    "4422",
    "4423",
    "4424",
    "4425",
    "4426",
    "4427",
    "4428",
    "4429",
    "4430",
    "4431",
    "4432",
    "4433",
    "4434",
    "4435",
    "4436",
    "4437",
    "4438",
    "4439",
    "4440",
    "4441",
    "4442",
    "4443",
    "4444",
    "4445",
    "4446",
    "4447",
    "4448",
    "4449",
    "4450",
    "4451",
    "4452",
    "4453",
    "4454",
    "4455",
    "4456",
    "4457",
    "4458",
    "4459",
    "4460",
    "4461",
    "4462",
    "4463",
    "4464",
    "4465",
    "4466",
    "4467",
    "4468",
    "4469",
    "4470",
    "4471",
    "4472",
    "4473",
    "4474",
    "4475",
    "4476",
    "4477",
    "4478",
    "4479",
    "4480",
    "4481",
    "4482",
    "4483",
    "4484",
    "4485",
    "4486",
    "4487",
    "4488",
    "4489",
    "4490",
    "4491",
    "4492",
    "4493",
    "4494",
    "4495",
    "4496",
    "4497",
    "4498",
    "4499",
    "4500",
    "4501",
    "4502",
    "4503",
    "4504",
    "4505",
    "4506",
    "4507",
    "4508",
    "4509",
    "4510",
    "4511",
    "4512",
    "4513",
    "4514",
    "4515",
    "4516",
    "4517",
    "4518",
    "4519",
    "4520",
    "4521",
    "4522",
    "4523",
    "4524",
    "4525",
    "4526",
    "4527",
    "4528",
    "4529",
    "4530",
    "4531",
    "4532",
    "4533",
    "4534",
    "4535",
    "4536",
    "4537",
    "4538",
    "4539",
    "4540",
    "4541",
    "4542",
    "4543",
    "4544",
    "4545",
    "4546",
    "4547",
    "4548",
    "4549",
    "4550",
    "4551",
    "4552",
    "4553",
    "4554",
    "4555",
    "4556",
    "4557",
    "4558",
    "4559",
    "4560",
    "4561",
    "4562",
    "4563",
    "4564",
    "4565",
    "4566",
    "4567",
    "4568",
    "4569",
    "4570",
    "4571",
    "4572",
    "4573",
    "4574",
    "4575",
    "4576",
    "4577",
    "4578",
    "4579",
    "4580",
    "4581",
    "4582",
    "4583",
    "4584",
    "4585",
    "4586",
    "4587",
    "4588",
    "4589",
    "4590",
    "4591",
    "4592",
    "4593",
    "4594",
    "4595",
    "4596",
    "4597",
    "4598",
    "4599",
    "4600",
    "4601",
    "4602",
    "4603",
    "4604",
    "4605",
    "4606",
    "4607",
    "4608",
    "4609",
    "4610",
    "4611",
    "4612",
    "4613",
    "4614",
    "4615",
    "4616",
    "4617",
    "4618",
    "4619",
    "4620",
    "4621",
    "4622",
    "4623",
    "4624",
    "4625",
    "4626",
    "4627",
    "4628",
    "4629",
    "4630",
    "4631",
    "4632",
    "4633",
    "4634",
    "4635",
    "4636",
    "4637",
    "4638",
    "4639",
    "4640",
    "4641",
    "4642",
    "4643",
    "4644",
    "4645",
    "4646",
    "4647",
    "4648",
    "4649",
    "4650",
    "4651",
    "4652",
    "4653",
    "4654",
    "4655",
    "4656",
    "4657",
    "4658",
    "4659",
    "4660",
    "4661",
    "4662",
    "4663",
    "4664",
    "4665",
    "4666",
    "4667",
    "4668",
    "4669",
    "4670",
    "4671",
    "4672",
    "4673",
    "4674",
    "4675",
    "4676",
    "4677",
    "4678",
    "4679",
    "4680",
    "4681",
    "4682",
    "4683",
    "4684",
    "4685",
    "4686",
    "4687",
    "4688",
    "4689",
    "4690",
    "4691",
    "4692",
    "4693",
    "4694",
    "4695",
    "4696",
    "4697",
    "4698",
    "4699",
    "4700",
    "4701",
    "4702",
    "4703",
    "4704",
    "4705",
    "4706",
    "4707",
    "4708",
    "4709",
    "4711",
    "4714",
    "4715",
    "4724",
    "4727",
    "4731",
    "4735",
    "4744",
    "4751",
    "4754",
    "4756",
    "4758",
    "4759",
    "4761",
    "4762",
    "4794",
    "4796",
    "4797",
  ],
  be: [
    "2040",
    "2910",
    "9060",
    "9130",
    "9170",
    "9180",
    "9185",
    "9190",
    "9960",
    "9960",
    "9961",
    "9961",
    "9968",
    "9970",
    "9980",
    "9981",
    "9982",
    "9988",
    "9992",
  ],
};
